export type EmergencyButtonPosition =
  | "bottom-right"
  | "bottom-left"
  | "top-right"
  | "top-left";

export interface EmergencyButtonConfig {
  user_id: string;
  enabled: boolean;
  label: string;
  icon: string;
  color_hsl: string;
  position: EmergencyButtonPosition;
  show_on_lock: boolean;
  updated_at: string;
}

export type ReportReason =
  | "harassment"
  | "hate_speech"
  | "sexual_content"
  | "minor_safety"
  | "impersonation"
  | "spam_scam"
  | "self_harm"
  | "violence_threat"
  | "illegal_activity"
  | "other";

export const REPORT_REASON_LABELS: Record<ReportReason, string> = {
  harassment: "Harassment or bullying",
  hate_speech: "Hate speech",
  sexual_content: "Unwanted sexual content",
  minor_safety: "Minor safety concern",
  impersonation: "Impersonation",
  spam_scam: "Spam or scam",
  self_harm: "Self-harm content",
  violence_threat: "Violence or threats",
  illegal_activity: "Illegal activity",
  other: "Something else",
};

export interface CrisisResource {
  id: string;
  app: string | null;
  country: string | null;
  category: string;
  name: string;
  phone: string | null;
  sms: string | null;
  url: string | null;
  hours: string | null;
  languages: string[] | null;
  notes: string | null;
  display_order: number;
  active: boolean;
}

/**
 * Locale → primary emergency dial number.
 * Resolved client-side from navigator.language.
 * Conservative fallback: 911 (NA), 112 (EU/most other).
 */
export function resolveEmergencyNumber(locale?: string | null): string {
  const loc = (locale ?? (typeof navigator !== "undefined" ? navigator.language : "en-US")).toLowerCase();
  const region = loc.split("-")[1] ?? "";
  const NA = ["us", "ca", "mx"];
  const UK = ["gb", "uk"];
  const AU = ["au"];
  const NZ = ["nz"];
  if (NA.includes(region)) return "911";
  if (UK.includes(region)) return "999";
  if (AU.includes(region)) return "000";
  if (NZ.includes(region)) return "111";
  // EU and most of the world
  return "112";
}
